import { Space, Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface MissingScreenProps {
  title: ReactNode
  children: ReactNode
}

export const MissingScreen = ({ children, title }: MissingScreenProps): ReactElement => {
  return (
    <Styled.MissingScreenWrapper>
      <Text variant="h4">{title}</Text>
      <Space size="s8" />
      {children}
    </Styled.MissingScreenWrapper>
  )
}
